import { ReactNode, useState } from "react";

import { paymentIssueResolutionViewModes } from "../../../enums";
import { SwitchAppContentSwitcher } from "../../../components";

export const PaymentIssueResolutionViewModeSelector = (props: {
  defaultMode?: paymentIssueResolutionViewModes;
  acceptAsPartialPaymentView: ReactNode;
  refundToCustomerView: ReactNode;
  settleToMerchantBalanceView: ReactNode;
  redirectToInvoiceView: ReactNode;
}) => {
  const [viewMode, setViewMode] = useState<paymentIssueResolutionViewModes>(
    paymentIssueResolutionViewModes.acceptAsPartialPaymentView
  );

  return (
    <>
      <SwitchAppContentSwitcher<paymentIssueResolutionViewModes>
        onChange={({ name }) => {
          setViewMode(name);
        }}
        options={[
          {
            key: "Accept As Partial Payment",
            value: paymentIssueResolutionViewModes.acceptAsPartialPaymentView,
          },
          {
            key: "Refund Customer",
            value: paymentIssueResolutionViewModes.refundToCustomerView,
          },
          {
            key: "Settle To Balance",
            value: paymentIssueResolutionViewModes.settleToMerchantBalanceView,
          },
          {
            key: "Redirect To Invoice",
            value: paymentIssueResolutionViewModes.redirectToInvoiceView,
          },
        ]}
        selectedValue={viewMode}
      />

      <div className="mt-5">
        {viewMode === paymentIssueResolutionViewModes.acceptAsPartialPaymentView
          ? props.acceptAsPartialPaymentView
          : viewMode === paymentIssueResolutionViewModes.refundToCustomerView
          ? props.refundToCustomerView
          : viewMode ===
            paymentIssueResolutionViewModes.settleToMerchantBalanceView
          ? props.settleToMerchantBalanceView
          : props.redirectToInvoiceView}
      </div>
    </>
  );
};
